import { useState } from 'react';

const items = [
  { icon: 'ri-map-pin-line', text: '福岡・九州全域 出張買取対応' },
  { icon: 'ri-car-line', text: '出張費・査定費 完全0円' },
  { icon: 'ri-money-cny-circle-line', text: '即日現金お支払い' },
  { icon: 'ri-map-2-line', text: '九州8県＋中国・四国・近畿 対応' },
  { icon: 'ri-time-line', text: '年中無休・土日祝も対応' },
  { icon: 'ri-shield-check-line', text: '福岡県公安委員会 古物商許可取得店' },
  { icon: 'ri-gift-line', text: '遺品整理・生前整理も承ります' },
  { icon: 'ri-price-tag-3-line', text: '貴金属・ブランド品など12ジャンル 高価買取' },
  { icon: 'ri-home-heart-line', text: 'ご自宅へ無料出張 — 福岡発 当日対応可' },
];

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-10 bg-stone-900 text-white flex items-center overflow-hidden">
      {/* Scrolling track */}
      <div className="flex-1 overflow-hidden relative">
        <div className="flex animate-marquee whitespace-nowrap">
          {[...items, ...items].map((item, i) => (
            <span key={i} className="inline-flex items-center gap-2 px-8 text-sm">
              <span className="w-4 h-4 flex items-center justify-center text-amber-400">
                <i className={item.icon} />
              </span>
              <span className="font-medium tracking-wide">{item.text}</span>
              <span className="text-stone-600 ml-6">／</span>
            </span>
          ))}
        </div>
      </div>

      {/* Close button */}
      <button
        onClick={() => setVisible(false)}
        className="shrink-0 w-10 h-10 flex items-center justify-center text-stone-400 hover:text-white transition-colors cursor-pointer"
        aria-label="閉じる"
      >
        <i className="ri-close-line text-base" />
      </button>
    </div>
  );
}
